export const LOAN_CALCULATION_REQUEST =
  'user.borrower.local_calculator.LOAN_CALCULATION_REQUEST'
export const LOAN_CALCULATION_SUCCESS =
  'user.borrower.local_calculator.LOAN_CALCULATION_SUCCESS'
export const LOAN_CALCULATION_FAILURE =
  'user.borrower.local_calculator.LOAN_CALCULATION_FAILURE'
